/* eslint-disable arrow-body-style */
import React from 'react';
import classNames from 'classnames';
import SvgIcon from '@home/components/SvgIcon';
import './index.scss';
import CommonBubble from '@home/components/CommonBubble';
import { getLanguage } from '@home/utils/common';
import { useIntl } from 'umi';
import { LANGUAGE_EN } from '@home/_config/config';

interface IProps {
  className?: string;
  style?: React.CSSProperties;
  onClick:  () => void;
  showModal: boolean;
}

export default function EditIcon(props: IProps) {
  const { className, style, onClick, showModal } = props || {};
  const { locale } = useIntl(); // 中英切换方法
  const isEN = locale === LANGUAGE_EN;

  return (
    <>
      <CommonBubble content={getLanguage(isEN, 'Edit', '编辑')}>
        <span 
          className={classNames('dbh-studio-highlights-edit', className, {
            'dbh-studio-highlights-edit-clicked': showModal
          })}
          style={style}
          onClick={onClick}
        >
          <SvgIcon className='dbh-studio-highlights-edit-icon' type="edit-icon" />
        </span>
      </CommonBubble>
    </>
  );
}
